class SwiperScrollingContent extends HTMLElement {
  connectedCallback() {
    const Swiper = window.Swiper;
    const swiperEl = this.querySelector('.swiper');
    if (!Swiper || !swiperEl) return;

    const speed     = parseFloat(this.getAttribute('speed') || '5') || 5;
    const direction = this.getAttribute('direction') ?? 'end-to-start';

    const wrapper = swiperEl.querySelector('.swiper-wrapper');
    const originals = Array.from(wrapper.children);
    while (wrapper.children.length < originals.length * 6) {
      originals.forEach(slide => wrapper.appendChild(slide.cloneNode(true)));
    }

    this._swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      loop: true,
      loopAdditionalSlides: 10,
      allowTouchMove: false,
      freeMode: {
        enabled: true,
        momentum: false,
      },
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: this.hasAttribute('pause-on-hover'),
        reverseDirection: direction === 'start-to-end',
      },
      speed: speed * 1000,
    });
  }

  disconnectedCallback() {
    this._swiper?.destroy(true, true);
    this._swiper = null;
  }
}

customElements.define('swiper-scrolling-content', SwiperScrollingContent);
